import PageNotFound from '@/modules/core/pages/PageNotFound'
import coreRouter from '@/modules/core/routers/routers'
import userRouter from '@/modules/personal_account/routers/routers'
import { createRouter, createWebHistory } from 'vue-router'
import { authRequiredHook, instanceRequiredHook, userStatusHook } from "@/router/hooks"

const baseRoutes = [
  {
    path: '/:pathMatch(.*)*',
    name: 'PageNotFound',
    component: PageNotFound
  }
]
let allRoutes = []

allRoutes = allRoutes.concat(
  baseRoutes,
  coreRouter,
  userRouter
)

const router = createRouter(
  {
    base: '',
    // поправить когда-то
    history: createWebHistory(process.env.BASE_URL),
    routes: allRoutes
  }
)

router.beforeEach(authRequiredHook)
router.beforeEach(userStatusHook)
router.beforeEach(instanceRequiredHook)

export default router
